import { useEffect, useState } from 'react';
import classes from '../../Table/Table.module.css';

const AssignPassesModal = ({
  isOpen,
  onClose,
  onAssignPasses,
  locationName,
  currentPasses = 0,
  maxPasses = 100,
  totalPassesAllocatedToTheCompany,
  locationId,
  isLoading = false
}) => {
  const [passCount, setPassCount] = useState(0);
  const [action, setAction] = useState('add');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (passCount <= 0) {
      setError('Number of passes must be greater than 0');
      return;
    }
    if(action === 'reduce' && passCount > maxPasses-currentPasses) {
      setError('You don\'t have enough passes to reduce available passes ' + (maxPasses-currentPasses));
      return;
    }
    if(action === 'add' && passCount > totalPassesAllocatedToTheCompany) {
      setError('Number of passes to add cannot be greater than max passes');
      return;
    }
    const payload = {
      locationId: locationId,
      passes: passCount,
      action: action
    };
    
    onAssignPasses(payload);
  };

  const handleActionChange = (e) => {
    setPassCount(0);
    setAction(e.target.value);
  };

  if (!isOpen) return null;

  return (
    <div className={classes.modalOverlay} onClick={onClose}>
      <div className={classes.modalContent} onClick={e => e.stopPropagation()}>
        <div className={classes.modalHeader}>
          <h3>Assign Passes to {locationName}</h3>
          <button className={classes.closeButton} onClick={onClose}>&times;</button>
        </div>
        <div className={classes.modalBody}>
          <form onSubmit={handleSubmit}>
            <div className={`form-group ${classes.formGroup}`}>
              <div className={`form-group ${classes.radioGroup}`}>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="actionType"
                    id="addPasses"
                    value="add"
                    checked={action === 'add'}
                    onChange={handleActionChange}
                  />
                  <label className="form-check-label" htmlFor="addPasses">
                    Add Passes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="actionType"
                    id="reducePasses"
                    value="reduce"
                    checked={action === 'reduce'}
                    onChange={handleActionChange}
                    disabled={maxPasses === 0}
                  />
                  <label className={`form-check-label ${maxPasses === 0 ? 'text-muted' : ''}`} htmlFor="reducePasses">
                    Reduce Passes {maxPasses === 0 ? '(Not Available)' : ''}
                  </label>
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="passCount">
                  Number of Passes to {action === 'add' ? 'Add' : 'Reduce'}
                </label>
                <input
                  type="number"
                  id="passCount"
                  className={`form-control ${error ? 'is-invalid' : ''}`}
                  value={passCount}
                  onChange= {(e) => {
                    setPassCount(parseInt(e.target.value));
                    if (error) setError('');
                  }}
                />
                {error && <div className={classes.errorText}>{error}</div>}
              </div>
              
              <div className={classes.passInfo}>
                Current passes: {currentPasses} | Max available: {maxPasses}
              </div>
              <div className={classes.passInfo}>
                Total Pass Count Available For The Company: {totalPassesAllocatedToTheCompany}
              </div>
            </div>
            <div className={classes.modalFooter}>
              <button 
                type="button" 
                className={`btn btn-secondary ${classes.cancelButton}`}
                onClick={onClose}
                disabled={isLoading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className={`btn btn-primary ${classes.submitButton}`}
                disabled={isLoading}
              >
                {isLoading ? 'Processing...' : `${action === 'add' ? 'Add' : 'Reduce'} Passes`}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AssignPassesModal;
